import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { setToken } from "@/axios/setToken";
import store from "@/store/store";
let vm = new Vue();
NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
});
Vue.use(Router);
import homeChildren from "./children/home";
const commonRoutes = [
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: () => import("@/pages/login/index"),
  //   meta: {
  //     title: "登录"
  //   }
  // },
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/home/index"),
    meta: {
      title: "首页"
    },
    redirect: { name: "fourIndex" },
    //此处通过homeChildren 文件引入主页需求的路由
    children: [...homeChildren]
  },
  {
    path: "*",
    name: "home",
    component: () => import("@/pages/home/index"),
    meta: {
      title: "首页"
    },
    redirect: { name: "fourIndex" }
  }
];
const createRouter = new Router({
  routes: [...commonRoutes]
});
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
createRouter.beforeEach((to, from, next) => {
  NProgress.start();
  window.document.title = to.meta.title;
  if (to.path != "/fourIndex") {
    let firstEnter = null;
    firstEnter = sessionStorage.getItem("firstEnter");
    if (firstEnter) {
      let timer = new Date().getTime();
      let count = timer - Number(firstEnter);
      if (count < 1000 * 60 * 60 * 24) {
        next();
      } else {
        let timer = new Date().getTime().toString();
        sessionStorage.setItem("firstEnter", timer);
        next({ path: "/fourIndex" });
      }
    } else {
      let timer = new Date().getTime().toString();
      sessionStorage.setItem("firstEnter", timer);
      next({ path: "/fourIndex" });
    }
  } else {
    let timer = new Date().getTime().toString();
    sessionStorage.setItem("firstEnter", timer);
    next();
  }
  if (document.readyState === "complete") {
    NProgress.done(true);
  } else {
    setTimeout(() => {
      if (document.readyState === "complete") {
        NProgress.done(true);
      } else {
        vm.$message({
          message: "当前网络较慢，请检查网络状态！",
          type: "warning"
        });
        // window.location.reload();
      }
    }, 2000);
  }
});
export default createRouter;



// WEBPACK FOOTER //
// ./src/router/index.js